/* tslint:disable */
/* eslint-disable */
/**
 * crm-phone-agent
 * crm-phone-agent
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalInstructions
 */
export interface InternalInstructions {
    /**
     * Instructions for navigating the IVR
     */
    ivr_instructions?: string;
    /**
     * Instructions for the conversation agent
     */
    conversation_instructions?: string;
}

/**
 * Check if a given object implements the InternalInstructions interface.
 */
export function instanceOfInternalInstructions(value: object): value is InternalInstructions {
    return true;
}

export function InternalInstructionsFromJSON(json: any): InternalInstructions {
    return InternalInstructionsFromJSONTyped(json, false);
}

export function InternalInstructionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalInstructions {
    if (json == null) {
        return json;
    }
    return {
        
        'ivr_instructions': json['ivr_instructions'] == null ? undefined : json['ivr_instructions'],
        'conversation_instructions': json['conversation_instructions'] == null ? undefined : json['conversation_instructions'],
    };
}

export function InternalInstructionsToJSON(json: any): InternalInstructions {
    return InternalInstructionsToJSONTyped(json, false);
}

export function InternalInstructionsToJSONTyped(value?: InternalInstructions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ivr_instructions': value['ivr_instructions'],
        'conversation_instructions': value['conversation_instructions'],
    };
}

